module.exports = "<div uib-dropdown> <input name=\"{{ $ctrl.fieldName }}\" ng-model=$ctrl.selectedDisplay ng-required=$ctrl.isRequired type=hidden> <div ng-class=\"{disabled: $ctrl.isDisabled, invalid: $ctrl.isInvalid}\" uib-dropdown-toggle tabindex=0 class=form-control> {{ $ctrl.selectedDisplay[$ctrl.itemDisplayProp] || $ctrl.emptyDisplayName }} </div> <ul uib-dropdown-menu role=menu> <li ng-repeat=\"item in $ctrl.itemList\" role=menuitem> <a ng-click=\"$ctrl.onItemSelect({item: item})\"> {{ item[$ctrl.itemDisplayProp] }} </a> </li> </ul> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/common/custom-dropdown/custom-dropdown.html
// module id = 337
// module chunks = 0